import { Component, Input } from '@angular/core';
import { Lang, LanguageService } from 'src/app/services/language.service';

/** -i18n- Bouton FR | EN | AR (en-tête et page de connexion). dir="ltr" : même ordre dans les 3 langues. */
@Component({
  selector: 'app-lang-switch',
  template: `
    <span class="lang-switch" [class.light]="light" dir="ltr">
      <button type="button" [class.active]="lang.current === 'fr'" (click)="set('fr')" aria-label="Français">FR</button>
      <span class="sep">|</span>
      <button type="button" [class.active]="lang.current === 'en'" (click)="set('en')" aria-label="English">EN</button>
      <span class="sep">|</span>
      <button type="button" [class.active]="lang.current === 'ar'" (click)="set('ar')" aria-label="العربية">AR</button>
    </span>`,
  styles: [`
    .lang-switch { display: inline-flex; align-items: center; gap: 2px; font-size: 13px; }
    .lang-switch button { background: none; border: 0; padding: 2px 4px; cursor: pointer; color: #6b7075; font-weight: 500; }
    .lang-switch button.active { color: #BF0404; font-weight: 700; }
    .lang-switch .sep { color: #c8ccd0; }
    .lang-switch.light button { color: rgba(255,255,255,.75); }
    .lang-switch.light button.active { color: #fff; text-decoration: underline; }
    .lang-switch.light .sep { color: rgba(255,255,255,.5); }
  `]
})
export class LangSwitchComponent {
  /** true sur fond sombre (en-tête rouge). */
  @Input() light = false;

  constructor(public lang: LanguageService) {}

  set(l: Lang): void {
    this.lang.use(l);
  }
}
